module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou1-620d25ba0088b85ca8ba2f5a1f878d1c.jpg";